import React from 'react'
import Layout from '../Layout'
 
import First_pane from './First_pane'



const Acci_ultra = () => {
  return (
    <Layout>
        <First_pane />
    </Layout>
  )
}

export default Acci_ultra